<div class="layout_center">
  <!-- FPLZF-857 siehe kommentar in typescript-file -->
  <div class="layout_centered_content">
    <div class="layout_columns">
      <div class="layout_columns_main var_no_nbc">
        <h1 class="mod_pagetitle " style="text-align: left;" i18n>Seite nicht gefunden (404)</h1>
        <div class="mod_lead_text " style="text-align: left;">
          <p i18n>Sorry, hier geht es nicht weiter!<br/></p>
        </div>

        <div class="mod_media">
          <figure class="mod_image" data-media="image_wrapper">
            <div class="mod_image_inner_wrapper ">
              <picture>
                <source
                  data-srcset="https://cdn.img.sbb.ch/content/dam/internet/sharedimages/zug/sonstiges/u218069_Seitensansicht_Lokomotive.jpg?w=320&amp;h=180&amp;auto=format,compress,cs=tinysrgb&amp;q=45 320w, https://cdn.img.sbb.ch/content/dam/internet/sharedimages/zug/sonstiges/u218069_Seitensansicht_Lokomotive.jpg?w=640&amp;h=360&amp;auto=format,compress,cs=tinysrgb&amp;q=30 640w, https://cdn.img.sbb.ch/content/dam/internet/sharedimages/zug/sonstiges/u218069_Seitensansicht_Lokomotive.jpg?w=1280&amp;h=720&amp;auto=format,compress,cs=tinysrgb&amp;q=30 1280w"
                  media="(max-width:642px)"/>
                <source
                  data-srcset="https://cdn.img.sbb.ch/content/dam/internet/sharedimages/zug/sonstiges/u218069_Seitensansicht_Lokomotive.jpg?w=976&amp;h=549&amp;auto=format,compress,cs=tinysrgb&amp;q=45 976w, https://cdn.img.sbb.ch/content/dam/internet/sharedimages/zug/sonstiges/u218069_Seitensansicht_Lokomotive.jpg?w=1952&amp;h=1098&amp;auto=format,compress,cs=tinysrgb&amp;q=30 1952w"
                  media="(max-width:1024px)"/>
                <source
                  data-srcset="https://cdn.img.sbb.ch/content/dam/internet/sharedimages/zug/sonstiges/u218069_Seitensansicht_Lokomotive.jpg?w=1000&amp;h=562&amp;auto=format,compress,cs=tinysrgb&amp;q=45 1000w, https://cdn.img.sbb.ch/content/dam/internet/sharedimages/zug/sonstiges/u218069_Seitensansicht_Lokomotive.jpg?w=2000&amp;h=1124&amp;auto=format,compress,cs=tinysrgb&amp;q=30 2000w"
                  media="(min-width:1025px)"/>
                <img
                  data-src="/content/dam/internet/sharedimages/zug/sonstiges/u218069_Seitensansicht_Lokomotive.jpg/_jcr_content/renditions/cq5dam.web.1280.1280.jpeg"
                  class="mod_image_figure var_lazyload" alt="" data-media="image"/>
              </picture>
              <noscript>
                <img
                  src="/content/dam/internet/sharedimages/zug/sonstiges/u218069_Seitensansicht_Lokomotive.jpg/_jcr_content/renditions/cq5dam.web.1280.1280.jpeg"
                  class="mod_image_figure" alt=""/>
              </noscript>


              <!--[if lte IE 8]><img
              src="/content/dam/internet/sharedimages/zug/sonstiges/u218069_Seitensansicht_Lokomotive.jpg/_jcr_content/renditions/cq5dam.web.1280.1280.jpeg"
              class="mod_image_figure"
              alt=""
              aria-describedby=""/><![endif]-->

            </div>
          </figure>
        </div>
      </div>
    </div>
  </div>
</div>
